/* eslint-disable react/no-array-index-key */
import { GridLayout } from '@deity/falcon-ui';
import { Box, FlexLayout, Icon } from '@deity-io/portal-ui';
import { IconButton } from 'components/IconButton/IconButton';
import type { FC } from 'react';
import type { ValidateToSchemaResult } from 'services/graphql/generated/schemas';

interface ResponseStructureProps {
  locked?: boolean;
  report: ValidateToSchemaResult;
  refresh?: () => void;
}

const ValidationReport: FC<ResponseStructureProps> = ({ locked, report, refresh }) => (
  <Box sx={{ padding: '10px' }}>
    <FlexLayout direction="row">
      {report.valid ? <Icon icon="check" color="success" /> : <Icon icon="error" color="error" />}
      {report.valid ? (
        <Box>The structure will parse the input data</Box>
      ) : (
        <Box>The structure will not parse the input data</Box>
      )}
      {refresh && <IconButton sx={{ marginLeft: 'auto', marginRight: '0px' }} icon="refresh" onClick={refresh} />}
    </FlexLayout>
    <GridLayout gridTemplateColumns="1fr 5fr 20fr">
      {[
        ...(report.errors?.map((error, index) => [
          <Icon key={`errorIcon${index}`} icon="error" color="error" />,
          <Box key={`errorPath${index}`}>{`${error.path}`}</Box>,
          <Box key={`errorMessage${index}`}>{`${error.message}`}</Box>
        ]) || []),
        ...(report.warnings?.map((warning, index) => [
          <Icon key={`warningIcon${index}`} icon="warning" color="warning" />,
          <Box key={`warningPath${index}`}>{`${warning.path}`}</Box>,
          <Box key={`warningMessage${index}`}>{`${warning.message}`}</Box>
        ]) || [])
      ]}
    </GridLayout>
  </Box>
);

export default ValidationReport;
